@if ('showLinkToTermsOfUse' | feature | async) {
    @if (user()) {
        <div>
            <a [routerLink]="('frame.footer.nutzungsbedingungen.filename' | msgKey) + (user().uiLanguage) + '.pdf'"
               target="_blank">
                {{"frame.footer.nutzungsbedingungen" | msgKey}}
            </a>
        </div>
    } @else {
        @if ('showLinkToTermsOfUseBeforeLogin' | feature | async) {
            <div>
                <a routerLink="{{'frame.footer.nutzungsbedingungen.filename' | msgKey}}{{ ('i18nDefaultUiLanguage' | featureValue | async) }}.pdf"
                   target="_blank">
                    {{"frame.footer.nutzungsbedingungen" | msgKey}}
                </a>
            </div>
        }
    }
}
